import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormSpecialDiscount } from './FormSpecialDiscount';
import { AuthorizedSpecialDiscount } from './AuthorizedSpecialDiscount';
import { DeleteSpecialDiscount } from './DeleteSpecialDiscount';
import { Dialog } from "primereact/dialog";

export const ModalSpecialDiscount = (props) => {

    const {
        modalSpecialDiscount, closeDialogSpecialDiscount, methodSpecialDiscount, modalTitle,
        loading, percentage, percentage_global, listExams, listProfiles, listSelectedExams, listSelectedProfiles,
        idSpecialDiscount, id_exam_include, id_profile_include,
        handleInputChange, handleChangeTypeDiscount, handleExamsIncludes, handleProfileIncludes, handleInputPercentageIndividual,
        validationsSpecialDiscount,
        saveCreate, handleRemoveTest,
        saveAuthorized, saveUpdate, saveDelete, handleSearchChange
    } = props;

    const dialogTheme = methodSpecialDiscount === "delete"
        ? `seller-dialog seller-danger seller-small-v`
        : "seller-dialog seller-blue Global-medium3 ";


    return (
        <Dialog
            visible={modalSpecialDiscount}
            onHide={closeDialogSpecialDiscount}
            modal
            closable={false}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-sale-discount f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}
            className={`seller-dialog ${dialogTheme}`}


        >

            {
                (methodSpecialDiscount === "create" || methodSpecialDiscount === "view" || methodSpecialDiscount === "update")
                    ?
                    <FormSpecialDiscount
                        readOnly={methodSpecialDiscount === "view" ? true : false}
                        button="Crear descuento especial"
                        methodAction={methodSpecialDiscount === "create" ? saveCreate : saveUpdate}
                        {
                        ...{
                            closeDialogSpecialDiscount, loading,
                            handleInputChange, handleChangeTypeDiscount, percentage, percentage_global,
                            id_exam_include, id_profile_include,
                            listExams, listProfiles, listSelectedExams, listSelectedProfiles, handleInputPercentageIndividual,
                            handleExamsIncludes, handleProfileIncludes,
                            validationsSpecialDiscount,
                            handleRemoveTest, handleSearchChange
                        }
                        }
                    />
                    :
                    (methodSpecialDiscount === "auth")
                        ?
                        <AuthorizedSpecialDiscount
                            {...{ toggle: closeDialogSpecialDiscount, loading, saveAuthorized, idSpecialDiscount }}
                        />
                        :

                        (methodSpecialDiscount === "delete")
                            ?
                            <DeleteSpecialDiscount
                                {
                                ...{
                                    toggle: closeDialogSpecialDiscount, loading, saveDelete, idSpecialDiscount
                                }
                                }
                            />
                            : ""
            }
        </Dialog>
    )
}
